export default "__VITE_PUBLIC_ASSET__bd9ad3c5__"